const days = {
    en: {
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thu: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
        sun: 'Sunday',
    },
    sv: {
        mon: 'Måndag',
        tue: 'Tisdag',
        wed: 'Onsdag',
        thu: 'Torsdag',
        fri: 'Fredag',
        sat: 'Lördag',
        sun: 'Söndag',
    },
};

const shortDays = {
    en: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
    },
    sv: {
        mon: 'Mån',
        tue: 'Tis',
        wed: 'Ons',
        thu: 'Tor',
        fri: 'Fre',
        sat: 'Lör',
        sun: 'Sön',
    },
};

export function getBusinessDays(timing: any, format = 'full'): string {
    let businessDays = '';
    const daysArr = Object.keys(timing).filter((day) => timing[day]);
    if (isContiguous(daysArr)) {
        return format === 'full'
            ? `${days[this.i18NService.currentLang][daysArr[0]]}-${
                  days[this.i18NService.currentLang][daysArr[daysArr.length - 1]]
              }`
            : `${shortDays[this.i18NService.currentLang][daysArr[0]]}-${
                  shortDays[this.i18NService.currentLang][daysArr[daysArr.length - 1]]
              }`;
    }
    daysArr.forEach((day) => {
        if (format === 'full') {
            businessDays += days[this.i18NService.currentLang][day] + ', ';
        } else if (format === 'short') {
            businessDays += shortDays[this.i18NService.currentLang][day] + ', ';
        }
    });

    businessDays = businessDays.slice(0, -2);

    return businessDays;
}

function isContiguous(timingsArr: any): any {
    if (!timingsArr?.length) {
        return false;
    }
    const daysArr = Object.keys(days.en);
    let i = daysArr.indexOf(timingsArr[0]);
    let j = 0;
    while (i < daysArr.length && j < timingsArr.length) {
        if (timingsArr[j] !== daysArr[i]) {
            return false;
        }
        i++;
        j++;
    }
    return true;
}
